export const SW_VERSION = "24a7f9c049a9a56472214fba91de3594";